import React, { useState, useEffect,useRef } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import checkPermission from '../Utils/checkPermission';
import {
  TextField,
  Button,
  Paper,
  Grid,
  Typography,
  Tabs,
  Tab,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  IconButton,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
 
  Dialog,
DialogTitle,
DialogContent,
DialogActions,
  Alert
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import HeaderMenu from '../Header/HeaderMenu';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { API_BASE_URL } from '../../config';
import './CreateHostel.css';
import axiosApi from '../Utils/axiosApi';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import useMediaQuery from '@mui/material/useMediaQuery';
const facilitiesList = [
  { name: "wifi", label: "Wi-Fi" },
  { name: "parking", label: "Parking" },
  { name: "laundry", label: "Laundry" },
  { name: "gym", label: "Gym" },
];

const CreateHostel = ({ hostel, isDialog, onClose }) => {
  const location = useLocation();
 
  const isMobile = useMediaQuery('(max-width:599.95px)');

  // *******************
  // 1. Form state
  // *******************
  const [formState, setFormState] = useState({
    companyId: hostel?.companyId || '',
	foodSafetyRegistration: hostel?.foodSafetyRegistration || '',
	hostelRegisterationNumber: hostel?.hostelRegisterationNumber || '',
    hostelName: hostel?.hostelName || '',
    cityId: hostel?.cityId || '',
    districtId: hostel?.districtId || '',
    stateId: hostel?.stateId || '',
	lockIndicator: hostel?.lockIndicator || '',
	reservationOnly: hostel?.reservationOnly || '',
	displayPriorityScore: hostel?.displayPriorityScore || 1,
	propertyType: hostel?.propertyType || 'HOSTEL',
	
	menuType: hostel?.menuType || 'WEEKLY',
	visibilityType: hostel?.visibilityType || 'PUBLIC',
    countryId: hostel?.countryId || '',
    phoneNumber: hostel?.phoneNumber || '',
    mobileNumber: hostel?.mobileNumber || '',
	 hostelGenderType: hostel?.hostelGenderType || '',
    images: hostel?.images || [],
    imageNames: hostel?.imageNames || [],
    locationDescription: hostel?.locationDescription || '',
    pricingGrid: [{ foodPrice: { oneDay: '', oneWeek: '', oneMonth: '' }, discount: {}, validity: {} }],
    includeFood: false,
    rent: {
      oneDay: '',
      oneWeek: '',
      oneMonth: '',
      sixMonths: '',
      oneYear: '',
    },
    foodCost: {
      oneDay: '',
      oneWeek: '',
      oneMonth: '',
    },
    discounts: {
      rent: { oneMonth: '', sixMonths: '', oneYear: '' },
      food: { oneMonth: '', sixMonths: '', oneYear: '' },
      couponCode: '',
    },
    roomDetails: [],
    linkedInstitute: hostel?.linkedInstitute || '',
    facilities: {
      wifi: hostel?.hostelFacilityDTO?.wifi === "true",
      parking: hostel?.hostelFacilityDTO?.parking === "true",
      laundry: hostel?.hostelFacilityDTO?.laundry === "true",
      gym: hostel?.hostelFacilityDTO?.gym === "true",
    },
    hostelOverview: hostel?.hostelOverview || '',
    hostelRule: hostel?.hostelRuleDTO?.hostelRuleDescription || '',
	
	modifiedAttributes: new Set(),
	
  // Add this line for image DTOs
  imageUploadConfigurationDTOs: hostel?.imageUploadConfigurationDTOs || []
  
  });

  // *******************
  // 2. Other state variables
  // *******************
  const [activeTab, setActiveTab] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Dynamic data states
  const [cities, setCities] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
const [selectedCategory, setSelectedCategory] = useState('');
const [imageErrorBanner, setImageErrorBanner] = useState('');

const alertRef = useRef(null);



// Room details popup
const [roomDetailsDialogOpen, setRoomDetailsDialogOpen] = useState(false);

const [selectedRoomIndex, setSelectedRoomIndex] = useState(null);




const openRoomDetailsDialog = (index) => {
  setSelectedRoomIndex(index);
  setRoomDetailsDialogOpen(true);
};

const closeRoomDetailsDialog = () => {
  setRoomDetailsDialogOpen(false);
  setSelectedRoomIndex(null);
};

  // *******************
  // 3. Fetch dynamic data
  // *******************

  // Fetch countries
  useEffect(() => {
    axiosApi.post(`${API_BASE_URL}/country/getCountry`, {})
      .then(response => {
        const countryArray = Array.isArray(response.data)
          ? response.data
          : response.data.countries || [];
        setCountries(countryArray);
      })
      .catch(error => {
        console.error("Error fetching countries:", error);
      });
  }, []);


  
  
  // Fetch states based on selected country
  useEffect(() => {
    if (formState.countryId) {
      axiosApi.post(`${API_BASE_URL}/state/getState`, { countryIds: [formState.countryId] })
        .then(response => {
          const stateArray = Array.isArray(response.data)
            ? response.data
            : response.data.states || [];
          setStates(stateArray);
        })
        .catch(error => {
          console.error("Error fetching states:", error);
          setStates([]);
        });
    } else {
      setStates([]);
    }
  }, [formState.countryId]);

  // Fetch districts based on selected state
  useEffect(() => {
    if (formState.stateId) {
      axiosApi.post(`${API_BASE_URL}/district/getDistrict`, { stateIds: [formState.stateId] })
        .then(response => {
          const districtArray = Array.isArray(response.data)
            ? response.data
            : response.data.districts || [];
          setDistricts(districtArray);
        })
        .catch(error => {
          console.error("Error fetching districts:", error);
          setDistricts([]);
        });
    } else {
      setDistricts([]);
    }
  }, [formState.stateId]);

  // Fetch cities based on selected district
  useEffect(() => {
    if (formState.districtId) {
      axiosApi.post(`${API_BASE_URL}/city/getCity`, { districtIds: [formState.districtId] })
        .then(response => {
          const cityArray = Array.isArray(response.data)
            ? response.data
            : response.data.cities || [];
          setCities(cityArray);
        })
        .catch(error => {
          console.error("Error fetching cities:", error);
          setCities([]);
        });
    } else {
      setCities([]);
    }
  }, [formState.districtId]);

const userRole = sessionStorage.getItem("userRole");
const companyId = sessionStorage.getItem("companyId");

  // Fetch companies
useEffect(() => {
  const companyRequestPayload = {};
  if (userRole !== "ADMIN") companyRequestPayload.companyId = companyId;

  axiosApi.post(`${API_BASE_URL}/company/getCompany`, companyRequestPayload)
    .then(response => {
      const companyArray = Array.isArray(response.data)
        ? response.data
        : response.data.companies || [];
      setCompanies(companyArray);
    })
    .catch(error => {
      console.error("Error fetching companies:", error);
    });
}, [userRole, companyId]);


  // Fetch room types
  useEffect(() => {
    axiosApi.post(`${API_BASE_URL}/refdata/getRoomType`, {})
      .then(response => {
        const roomTypeArray = Array.isArray(response.data)
          ? response.data
          : response.data.roomTypes || [];
        setRoomTypes(roomTypeArray);
      })
      .catch(error => {
        console.error("Error fetching room types:", error);
      });
  }, []);

  // Populate roomDetails if editing an existing hostel
 useEffect(() => {
  if (!hostel?.id || !Array.isArray(hostel.hostelRoomDTOs)) {
    return;
  }

  setFormState(prevState => ({
    ...prevState,
    roomDetails: hostel.hostelRoomDTOs.map(room => ({
      roomNumbers: room.roomNumber
        ? String(room.roomNumber)
            .split(',')
            .map(num => num.trim())
            .filter(Boolean)
        : [],

      roomType: room.roomType || '',

     roomCount: room.roomCount ?? 0,

      maximumRoomOccupancy:
        room.maximumRoomOccupancy ?? '',
inventoryTrackingType:
  room.inventoryTrackingType || 'ROOM_BASED',
      Period: room.accommodationPeriod || '',

      dailyPrice: room.dailyPrice ?? '',
      monthlyPrice: room.monthlyPrice ?? '',

      price2To3Hours: room.price2To3Hours ?? '',
      price4To6Hours: room.price4To6Hours ?? '',
      price6To12Hours: room.price6To12Hours ?? '',
microstayPricingEnabled:
  room.microstayPricingEnabled === "Y" ? "Y" : null,
      remark: room.description || '',

      fromDate: room.fromDate
        ? room.fromDate.split('T')[0]
        : '',

      toDate: room.toDate
        ? room.toDate.split('T')[0]
        : '',

      roomImage: null,

      roomImageName:
        room.roomImageName ?? '',

      roomImagePreview:
        room.roomImageUrl ??
        room.imageUrl ??
        ''
    }))
  }));
}, [hostel?.id, hostel?.hostelRoomDTOs]);


 useEffect(() => {
    if (formState.imageUploadConfigurationDTOs.length > 0) {
      const firstImageCategory = formState.imageUploadConfigurationDTOs[0].imageCategory;
      setSelectedCategory(firstImageCategory || '');
    }
  }, [formState.imageUploadConfigurationDTOs]);
  
  
  
  // *******************
  // 4. Handlers
  // *******************

  // Generic handler for text fields
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState(prevState => ({ ...prevState, [name]: value }));
  };

const handleImageUpload = async (event) => {
  if (!selectedCategory) {
    setImageErrorBanner("Please select an image category before uploading.");
    event.target.value = null;
    return;
  }

  const files = Array.from(event.target.files);
  if (files.length === 0) return;

  // Check if there's already an image in this category (either in new images or existing DTOs)
  const existingImageInCategory = [
    ...formState.images,
    ...formState.imageUploadConfigurationDTOs
  ].find(img => img.imageCategory === selectedCategory);

  if (existingImageInCategory) {
    setImageErrorBanner(`An image already exists for category "${selectedCategory}". Please delete it before uploading a new one.`);
    event.target.value = null;
    return;
  }

  const entityName = "Hostel";
  const uploadedImages = [];

  for (const file of files) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("entityName", entityName);

    try {
      const response = await axiosApi.post(`${API_BASE_URL}/sharedApi/uploadImage`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      const imageName = response.data.fileName || response.data.data?.fileName;
      if (!imageName) {
        console.warn("No imageName returned from server");
        continue;
      }

      uploadedImages.push({
        file,
        imageName,
        imageCategory: selectedCategory,
      });

    } catch (error) {
      console.error("Upload failed:", error.response?.data || error.message);
      setImageErrorBanner("Image upload failed. Please try again.");
    }
  }

  if (uploadedImages.length > 0) {
    setFormState(prevState => ({
      ...prevState,
      images: [...prevState.images, ...uploadedImages],
	  modifiedAttributes: new Set([...prevState.modifiedAttributes, 'hostelImage'])
    }));
    setImageErrorBanner(''); // clear banner on success
  }

  event.target.value = null;
};




const handleRemoveImage = async (indexToRemove) => {
  try {
    // Combine images with source metadata
    const combinedImages = [
      ...formState.images.map(img => ({ ...img, source: 'images' })),
      ...formState.imageUploadConfigurationDTOs.map(img => ({ ...img, source: 'dtos' })),
    ];

    const imageToDelete = combinedImages[indexToRemove];
    const imageNameToDelete = imageToDelete?.imageName;

    if (!imageNameToDelete) {
      console.warn('No image name found at index', indexToRemove);
      return;
    }

    // API call to delete the image
    await axiosApi.post(`${API_BASE_URL}/sharedApi/deleteImage`, null, {
      params: {
        entityName: imageToDelete.entityName || 'Hostel',
        imageNameToDelete,
      },
    });

    // Remove from correct source
    setFormState((prev) => {
      if (imageToDelete.source === 'images') {
        const updatedImages = prev.images.filter(img => img.imageName !== imageNameToDelete);
        return { ...prev, images: updatedImages };
      } else {
        const updatedDTOs = prev.imageUploadConfigurationDTOs.filter(img => img.imageName !== imageNameToDelete);
        return { ...prev, imageUploadConfigurationDTOs: updatedDTOs };
      }
    });

    console.log('Image removed successfully');
  } catch (error) {
    console.error('Error removing image:', error.response?.data || error.message);
  }
};

const handleRoomChange = (index, field, value) => {
  setFormState(prevState => ({
    ...prevState,
    roomDetails: prevState.roomDetails.map((room, i) =>
      i === index
        ? {
            ...room,
            [field]: value
          }
        : room
    )
  }));
};

  // Room details change handler
  const handleRoomNumberChange = (roomIndex, numberIndex, value) => {
  setFormState(prevState => {
    const updatedRoomDetails = [...prevState.roomDetails];

    const room = {
      ...updatedRoomDetails[roomIndex]
    };

    const updatedRoomNumbers = [
      ...(room.roomNumbers || [])
    ];

    updatedRoomNumbers[numberIndex] = value;

    room.roomNumbers = updatedRoomNumbers;

   

    updatedRoomDetails[roomIndex] = room;

    return {
      ...prevState,
      roomDetails: updatedRoomDetails
    };
  });
};

const addRoomNumber = (roomIndex) => {
  setFormState(prevState => ({
    ...prevState,
    roomDetails: prevState.roomDetails.map((room, index) => {
      if (index !== roomIndex) return room;

      const updatedNumbers = [
        ...(room.roomNumbers || []),
        ''
      ];

      return {
        ...room,
        roomNumbers: updatedNumbers
        
      };
    })
  }));
};

const removeRoomNumber = (roomIndex, numberIndex) => {
  setFormState(prevState => ({
    ...prevState,
    roomDetails: prevState.roomDetails.map((room, index) => {
      if (index !== roomIndex) return room;

      const updatedNumbers = (room.roomNumbers || [])
        .filter((_, i) => i !== numberIndex);

      return {
        ...room,
        roomNumbers: updatedNumbers
        
      };
    })
  }));
};
const handleRoomImageChange = async (index, file) => {
  if (!file) return;

  // Basic validation
  if (!file.type.startsWith('image/')) {
    setErrorMessage('Please select a valid image file.');
    return;
  }

  // Optional size limit: 5 MB
  if (file.size > 5 * 1024 * 1024) {
    setErrorMessage('Room image must be smaller than 5 MB.');
    return;
  }

  try {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('entityName', 'HostelRoom');

    const response = await axiosApi.post(
      `${API_BASE_URL}/sharedApi/uploadImage`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    const imageName =
      response.data.fileName ||
      response.data.data?.fileName;

    if (!imageName) {
      setErrorMessage('Room image upload failed.');
      return;
    }

    const previewUrl = URL.createObjectURL(file);

    setFormState(prevState => ({
      ...prevState,
      roomDetails: prevState.roomDetails.map((room, i) =>
        i === index
          ? {
              ...room,
              roomImage: file,
              roomImageName: imageName,
              roomImagePreview: previewUrl
            }
          : room
      )
    }));

    setErrorMessage('');

  } catch (error) {
    console.error(
      'Room image upload failed:',
      error.response?.data || error.message
    );

    setErrorMessage('Room image upload failed. Please try again.');
  }
};
const addRoom = () => {
  setFormState(prevState => ({
    ...prevState,
    roomDetails: [
      ...prevState.roomDetails,
      {
        roomNumbers: [''],
        roomType: '',
        roomCount: 1,
        maximumRoomOccupancy: '',
		inventoryTrackingType: 'ROOM_BASED',
		 microstayPricingEnabled: null, // Add this
        dailyPrice: '',
        monthlyPrice: '',
        price2To3Hours: '',
        price4To6Hours: '',
        price6To12Hours: '',
        remark: '',
        fromDate: '',
        toDate: '',
        roomImage: null,
        roomImageName: '',
        roomImagePreview: ''
      }
    ],
  }));
};

  const removeRoom = (index) => {
    setFormState(prevState => ({
      ...prevState,
      roomDetails: prevState.roomDetails.filter((_, i) => i !== index),
    }));
  };

  // Form submission: build payload matching your Java DTO (HostelDTO)
  const handleSubmit = (event) => {
    event.preventDefault();

    // Validate mandatory fields for hostel details
    if (!formState.hostelName || !formState.cityId || !formState.districtId || !formState.stateId || !formState.countryId || !formState.mobileNumber) {
      setErrorMessage("Please fill all mandatory fields: Hostel Name, City, District, State, Country, and Mobile Number.");
      return;
    }

    // Validate that at least one room detail is provided
    if (formState.roomDetails.length === 0) {
      setErrorMessage("Please add at least one room detail.");
      return;
    }

    // ✅ Validate that each room has: Room Type + (Daily OR Monthly Price)
for (let i = 0; i < formState.roomDetails.length; i++) {
  const room = formState.roomDetails[i];

  const hasRoomType = !!room.roomType;

  const hasDailyOrMonthly =
    Number(room.dailyPrice) > 0 ||
    Number(room.monthlyPrice) > 0;

  const hasHourlyPrice =
    Number(room.price2To3Hours) > 0 ||
    Number(room.price4To6Hours) > 0 ||
    Number(room.price6To12Hours) > 0;

const hasValidPrice = room.microstayPricingEnabled
  ? hasHourlyPrice
  : hasDailyOrMonthly;
  
  if (!hasRoomType || !hasValidPrice) {
    setErrorMessage(
      `Please fill mandatory fields for room ${i + 1}: Room Type and valid pricing.`
    );
    return;
  }
}


    setErrorMessage("");
    console.log('Form Submitted:', formState);

    // Build facilityDTO from facilities object
	const finalPriorityScore =
  formState.displayPriorityScore &&
  Number(formState.displayPriorityScore) > 0
    ? Number(formState.displayPriorityScore)
    : 1;
    const facilityDTO = {
      wifi: formState.facilities.wifi ? "true" : "false",
      gym: formState.facilities.gym ? "true" : "false",
      parking: formState.facilities.parking ? "true" : "false",
      laundry: formState.facilities.laundry ? "true" : "false"
    };

    // Build hostelRuleDTO only if hostelRule is provided
    const hostelRuleDTO = formState.hostelRule ? { hostelRuleDescription: formState.hostelRule } : undefined;

    // Build hostelRoomDTOs if room details exist
    const hostelRoomDTOs = formState.roomDetails.length > 0
  ? formState.roomDetails.map(room => ({
      roomNumber: (room.roomNumbers || [])
  .map(num => String(num).trim())
  .filter(Boolean)
  .join(','),

      roomType: room.roomType,

      roomCount: Number(room.roomCount) || 0,
maximumRoomOccupancy: Number(room.maximumRoomOccupancy) || 0,

      accommodationPeriod:
        room.Period || '',
inventoryTrackingType:
    room.inventoryTrackingType || 'ROOM_BASED',
      monthlyPrice:
        room.monthlyPrice,
microstayPricingEnabled:
  room.microstayPricingEnabled === "Y" ? "Y" : null,
      dailyPrice:
        room.dailyPrice,

      price2To3Hours:
        room.price2To3Hours,

      price4To6Hours:
        room.price4To6Hours,

      price6To12Hours:
        room.price6To12Hours,

      description:
        room.remark,

      fromDate:
        room.fromDate,

      toDate:
        room.toDate,

      // Uploaded room image name
      roomImageName:
        room.roomImageName || ''
    }))
  : undefined;

    // Look up the selected company name from companies array.
 
const imageNames = formState.images.map(img => img.imageName).filter(Boolean); // Filter out any undefined/null

const imageNameCategoryMap = {};

formState.images.forEach((img) => {
  if (img.imageName && img.imageCategory) {
    imageNameCategoryMap[img.imageName] = img.imageCategory;
  }
});


    // Construct the payload matching your Java DTO (HostelDTO)
    const payload = {
      hostelName: formState.hostelName,
      companyId: formState.companyId,
	  hostelRegisterationNumber: formState.hostelRegisterationNumber,
	  foodSafetyRegistration: formState.foodSafetyRegistration,
	  lockIndicator:formState.lockIndicator,
	  reservationOnly: formState.reservationOnly,
	  displayPriorityScore: finalPriorityScore,
	  propertyType: formState.propertyType,
	  menuType: formState.menuType,
visibilityType: formState.visibilityType,
      linkedInstitute: formState.linkedInstitute,
      cityId: formState.cityId,
      districtId: formState.districtId,
      stateId: formState.stateId,
	  imageFileNames:imageNames,
	  imageData: imageNameCategoryMap,
      countryId: formState.countryId,
      hostelOverview: formState.hostelOverview,
      phoneNumber: formState.phoneNumber,
      mobileNumber: formState.mobileNumber,
	  hostelGenderType: formState.hostelGenderType,
	   modifiedAttributes: Array.from(formState.modifiedAttributes),
      locationDescription: formState.locationDescription,
      hostelFacilityDTO: facilityDTO,
      ...(hostelRuleDTO && { hostelRuleDTO }),
      ...(hostelRoomDTOs && { hostelRoomDTOs }),
      ...(hostel?.id && { id: hostel.id }), // Include ID for updates
    };

    console.log("Payload to be submitted:", payload);

    // Choose endpoint based on whether updating or creating
    const endpoint = hostel ? `${API_BASE_URL}/hostel/updateHostelDetail` : `${API_BASE_URL}/hostel/createHostel`;
    axiosApi.post(endpoint, { hostelDTO: payload })
      .then(response => {
        console.log("Hostel processed successfully:", response.data);
        setSuccessMessage(hostel ? "Hostel updated successfully!" : "Hostel created successfully!");
        setErrorMessage("");
		 // ✅ Clear the modifiedAttributes after successful submission
    setFormState(prev => ({
      ...prev,
      modifiedAttributes: new Set(),
    }));
		
      })
      .catch(error => {
        console.error("Error processing hostel:", error);
        setErrorMessage("Error processing hostel. Please try again.");
        setSuccessMessage("");
				
      });
  };

useEffect(() => {
  if (errorMessage || successMessage) {
    setTimeout(() => {
      alertRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      alertRef.current?.focus();
    }, 100);
  }
}, [errorMessage, successMessage]);

  // Facilities handler: update facilities object
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormState(prevState => ({
      ...prevState,
      facilities: { ...prevState.facilities, [name]: checked },
    }));
  };

console.log(userRole); 
  return (
    <div className="create-hostel">
      {!isDialog && !location.state?.disableHeader && <HeaderMenu />}
      <Paper className="create-hostel-layout" elevation={0}>
        <Box className="create-hostel-heading">
          <Typography variant="h5" component="h1" gutterBottom>
            {hostel ? 'Edit Property Details' : 'Create New Property'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Manage property information, contacts, images, facilities and room pricing.
          </Typography>
        </Box>
        {(errorMessage || successMessage) && (
  <Box
    mb={2}
    ref={alertRef}
    tabIndex={-1}  // Make focusable
  >
    <Alert severity={errorMessage ? "warning" : "success"}>
      {errorMessage || successMessage}
    </Alert>
  </Box>
)}

        <form onSubmit={handleSubmit} className="tab-content">
         <Tabs
  value={activeTab}
  onChange={(event, newValue) => setActiveTab(newValue)}
  variant={isMobile ? "scrollable" : "fullWidth"}
  scrollButtons="auto"
  sx={{
    mb: 2,
    px: { xs: 0, sm: 1 },
    borderBottom: '1px solid #E2E8F0',
    '& .MuiTabs-indicator': {
      height: 3,
      borderRadius: '3px 3px 0 0',
      backgroundColor: '#2563EB',
    },
    '& .MuiTab-root': {
      minHeight: 54,
      textTransform: 'none',
      fontWeight: 600,
      fontSize: '0.875rem',
      color: '#64748B',
      px: { xs: 1.5, sm: 2.5 },
    },
    '& .Mui-selected': {
      color: '#1D4ED8',
    },
  }}
>
            <Tab label="General Info" />
            <Tab label="Contact Info" />
            <Tab label="Images" />
            <Tab label="Facilities & Rules" />
            <Tab label="Room Details" />
          </Tabs>
         <Box
  sx={{
    p: { xs: 1, sm: 2, md: 3 },
    width: '100%',
    boxSizing: 'border-box',
  }}
>
            {/* General Info Tab */}
            {activeTab === 0 && (
					<>
						<Typography className="create-hostel-section-title" variant="subtitle1" sx={{ mb: 2, fontWeight: 700 }}>
						  Basic Information
						</Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Property Name"
                    name="hostelName"
                    value={formState.hostelName}
                    onChange={handleChange}
                    fullWidth
                    required
                    error={!formState.hostelName}
                    helperText={!formState.hostelName ? "Hostel Name is required" : ""}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth required>
                    <InputLabel>Company Name</InputLabel>
                    <Select
                      label="Company Name"
                      name="companyId"
                      value={formState.companyId}
                      onChange={handleChange}
                    >
                      {companies.map((company) => (
                        <MenuItem key={company.id} value={company.id}>
                          {company.companyName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {/* Linked Industry as a TextField */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Linked Industry"
                    name="linkedInstitute"
                    value={formState.linkedInstitute}
                    onChange={handleChange}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth required error={!formState.countryId}>
                    <InputLabel>Country</InputLabel>
                    <Select
                      label="Country"
                      name="countryId"
                      value={formState.countryId}
                      onChange={handleChange}
                    >
                      {countries.map((country) => (
                        <MenuItem key={country.id} value={country.id}>
                          {country.countryName}
                        </MenuItem>
                      ))}
                    </Select>
                    {!formState.countryId && <FormHelperText>Country is required</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth required error={!formState.stateId}>
                    <InputLabel>State</InputLabel>
                    <Select
                      label="State"
                      name="stateId"
                      value={formState.stateId}
                      onChange={handleChange}
                    >
                      {states.map((state) => (
                        <MenuItem key={state.id} value={state.id}>
                          {state.stateName}
                        </MenuItem>
                      ))}
                    </Select>
                    {!formState.stateId && <FormHelperText>State is required</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth required error={!formState.districtId}>
                    <InputLabel>District</InputLabel>
                    <Select
                      label="District"
                      name="districtId"
                      value={formState.districtId}
                      onChange={handleChange}
                    >
                      {districts.map((district) => (
                        <MenuItem key={district.id} value={district.id}>
                          {district.districtName}
                        </MenuItem>
                      ))}
                    </Select>
                    {!formState.districtId && <FormHelperText>District is required</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth required error={!formState.cityId}>
                    <InputLabel>City</InputLabel>
                    <Select
                      label="City"
                      name="cityId"
                      value={formState.cityId}
                      onChange={handleChange}
                    >
                      {cities.map((city) => (
                        <MenuItem key={city.id} value={city.id}>
                          {city.cityName}
                        </MenuItem>
                      ))}
                    </Select>
                    {!formState.cityId && <FormHelperText>City is required</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Overview"
                    name="hostelOverview"
                    value={formState.hostelOverview}
                    onChange={handleChange}
                    fullWidth
                    multiline
                    rows={4}
                  />
                </Grid>
				
				{userRole === "ADMIN" && (
	  <>
		<Grid item xs={12} sm={4}>
		  <FormControlLabel
			control={
			  <Checkbox
				checked={formState.lockIndicator === 'Y'}
				onChange={(event) =>
				  setFormState((prev) => ({
					...prev,
					lockIndicator: event.target.checked ? 'Y' : '',
				  }))
				}
				name="lockIndicator"
				color="primary"
			  />
			}
			label="Lock Indicator"
		  />
		</Grid>

	   <Grid item xs={12} sm={4}>
	  <FormControlLabel
		control={
		  <Checkbox
			checked={formState.reservationOnly === 'Y'}
			onChange={(event) =>
			  setFormState((prev) => ({
				...prev,
				reservationOnly: event.target.checked ? 'Y' : '',
				modifiedAttributes: new Set([
				  ...prev.modifiedAttributes,
				  'reservationOnly'
				])
			  }))
			}
			name="reservationOnly"
			color="primary"
		  />
		}
		label="Reservation Only"
	  />
	</Grid>
	<Grid item xs={12} sm={4}>
				  <TextField
	  label="Priority Score"
	  name="displayPriorityScore"
	  type="number"
	  value={formState.displayPriorityScore || ''}
	  onChange={(e) => {
		const value = e.target.value;

		// allow only positive numbers or empty
		if (value === '' || Number(value) > 0) {
		  handleChange(e);
		}
	  }}
	  fullWidth
	  inputProps={{ min: 1 }}
	/>
					</Grid>
					<Grid item xs={12} sm={4}>
  <FormControl fullWidth size="small">
    <InputLabel>Property Type</InputLabel>
    <Select
      name="propertyType"
      value={formState.propertyType}
      onChange={handleChange}
    >
      <MenuItem value="HOSTEL">Hostel</MenuItem>
      <MenuItem value="HOTEL">Hotel</MenuItem>
	  <MenuItem value="PG">PG</MenuItem>
	  <MenuItem value="RESORT">Resort</MenuItem>
	  <MenuItem value="HOMESTAY">Homestays</MenuItem>
	  <MenuItem value="MICROSTAY">MicroStay</MenuItem>
    </Select>
  </FormControl>
</Grid>
				<Grid item xs={12} sm={4}>
  <FormControl fullWidth size="small">
    <InputLabel>Menu Type</InputLabel>
    <Select
      name="menuType"
      value={formState.menuType}
      onChange={handleChange}
    >
      <MenuItem value="WEEKLY">Weekly</MenuItem>
      <MenuItem value="STANDARD">Standard</MenuItem>
    </Select>
  </FormControl>
</Grid>


<Grid item xs={12} sm={4}>
  <FormControl fullWidth size="small">
    <InputLabel>Visibility</InputLabel>
    <Select
      name="visibilityType"
      value={formState.visibilityType}
      onChange={handleChange}
    >
      <MenuItem value="PUBLIC">Public</MenuItem>
      <MenuItem value="PRIVATE">Private (School only)</MenuItem>
    </Select>
  </FormControl>
</Grid>
	  </>
	)}


		
<Grid item xs={12} sm={4}>
                  <TextField
                    label="Property RegisterationNumber "
                    name="hostelRegisterationNumber"
                    value={formState.hostelRegisterationNumber}
                    onChange={handleChange}
                    fullWidth
                    
                    rows={1}
                  />
                </Grid>		
				<Grid item xs={12} sm={4}>
                  <TextField
                    label="Food SafetyRegistration "
                    name="foodSafetyRegistration"
                    value={formState.foodSafetyRegistration}
                    onChange={handleChange}
                    fullWidth
                    rows={4}
                  />
                </Grid>	
<Grid item xs={12} sm={4}>
   
				  <FormControl fullWidth size="small" required>
                <InputLabel>residentType</InputLabel>
                <Select
                  name="hostelGenderType"
                  value={formState.hostelGenderType}
                  onChange={handleChange}
                >
                  <MenuItem value="male">Male</MenuItem>
                  <MenuItem value="female">Female</MenuItem>
                  <MenuItem value="unisex">Unisex</MenuItem>
                </Select>
              </FormControl>
                </Grid>					
				
				
              </Grid>
			  </>
            )}
            {/* Contact Info Tab */}
            {activeTab === 1 && (
			<>
    <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
      Contac Information
    </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Phone Number"
                    name="phoneNumber"
                    value={formState.phoneNumber}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Mobile Number"
                    name="mobileNumber"
                    value={formState.mobileNumber}
                    onChange={handleChange}
                    fullWidth
                    required
                    error={!formState.mobileNumber}
                    helperText={!formState.mobileNumber ? "Mobile Number is required" : ""}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Location Description"
                    name="locationDescription"
                    value={formState.locationDescription}
                    onChange={handleChange}
                    fullWidth
                    multiline
                    rows={4}
                  />
                </Grid>
              </Grid>
			  </>
            )}
           {/* Images Tab */}
{activeTab === 2 && (
<>
			<Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
  Images Information
</Typography>
  <Grid container spacing={3}>
    <Grid item xs={12}>
	{imageErrorBanner && (
  <Box mb={2}>
    <Alert severity="warning" onClose={() => setImageErrorBanner('')}>
      {imageErrorBanner}
    </Alert>
  </Box>
)}
      <Typography variant="body1" gutterBottom>
        Upload Images:
      </Typography>
{/* Image Category Selection */}
          <FormControl fullWidth required style={{ marginBottom: '16px' }}>
            <InputLabel id="image-category-label">Image Category</InputLabel>
            <Select
              labelId="image-category-label"
              id="image-category"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <MenuItem value=""><em>None</em></MenuItem>
               <MenuItem value="PROFILE">Profile</MenuItem>
            </Select>
          </FormControl>
      {/* Hidden file input */}
      <input
        type="file"
        id="image-upload"
        multiple
        onChange={handleImageUpload}
        accept="image/*"
        style={{ display: 'none' }}
      />

      {/* Upload button */}
      <label htmlFor="image-upload">
        <Button
          variant="contained"
          component="span"
          color="primary"
          style={{ marginBottom: '16px' }}
        >
          Upload Images
        </Button>
      </label>

      {/* Combined images */}
      <Grid container spacing={3}>
        {(() => {
          const combinedImages = [
            ...formState.images,
            ...formState.imageUploadConfigurationDTOs
          ];

          return combinedImages.length > 0 ? (
            combinedImages.map((image, index) => {
              const isFile = image.file instanceof File;
              const imageSrc = isFile
                ? URL.createObjectURL(image.file)
                : image.imageUrl;

              return (
                <Grid item key={index} xs={6} sm={4} md={3}>
                  <div style={{ position: 'relative' }}>
                    <img
                      src={imageSrc}
                      alt={image.imageName || 'Uploaded image'}
                      style={{
                        width: '100%',
                        height: 120,
                        objectFit: 'cover',
                        borderRadius: 8,
                      }}
                      onLoad={() => {
                        if (isFile) URL.revokeObjectURL(imageSrc);
                      }}
                    />
                    <IconButton
                      size="small"
                      onClick={() => handleRemoveImage(index)}
                      style={{
                        position: 'absolute',
                        top: 4,
                        right: 4,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        color: 'white',
                      }}
                      aria-label="Remove image"
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </div>
                  <Typography variant="body2" noWrap>
                    {image.imageCategory}
                  </Typography>
                </Grid>
              );
            })
          ) : (
            <Typography variant="body2">No images selected</Typography>
          );
        })()}
      </Grid>
    </Grid>
  </Grid>
  </>
)}

            {/* Facilities & Rules Tab */}
            {activeTab === 3 && (
			<>
			<Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
  Facilities & Rules 
</Typography>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Facilities</FormLabel>
                    <FormGroup row>
                      {facilitiesList.map((facility) => (
                        <FormControlLabel
                          key={facility.name}
                          control={
                            <Checkbox
                              checked={formState.facilities[facility.name] || false}
                              onChange={handleCheckboxChange}
                              name={facility.name}
                            />
                          }
                          label={facility.label}
                        />
                      ))}
                    </FormGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Rule Description"
                    name="hostelRule"
                    value={formState.hostelRule}
                    onChange={handleChange}
                    fullWidth
                    multiline
                    rows={4}
                  />
                </Grid>
              </Grid>
			  </>
            )}
      {/* Room Details Tab */}
{activeTab === 4 && (
  <Box className="room-tab" sx={{ width: "100%", minWidth: 0 }}>
    <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
      Room Details
    </Typography>

    {formState.roomDetails.length === 0 && (
      <Paper
        variant="outlined"
        sx={{ p: 3, textAlign: "center", borderRadius: 2, mb: 2 }}
      >
        <Typography color="text.secondary" variant="body2">
          No room details added yet.
        </Typography>
      </Paper>
    )}

    {formState.roomDetails.map((room, index) => (
      <Paper
        key={index}
        variant="outlined"
        className="room-detail-card"
        sx={{
          p: { xs: 1.5, sm: 2.5 },
          mb: 2,
          borderRadius: 2,
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
            mb: 2,
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            Room {index + 1}
          </Typography>

        </Box>

        <Grid container spacing={2}>
          {/* Room Type */}
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth required>
              <InputLabel id={`room-type-label-${index}`}>
                Room Type
              </InputLabel>
              <Select
                labelId={`room-type-label-${index}`}
                label="Room Type"
                value={room.roomType || ""}
                onChange={(e) =>
                  handleRoomChange(index, "roomType", e.target.value)
                }
              >
                <MenuItem value="">
                  <em>Select room type</em>
                </MenuItem>
                {roomTypes.map((rt) => (
                  <MenuItem key={rt.id} value={rt.roomType}>
                    {rt.roomType}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>


          {/* Room Count */}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Room Count"
              type="number"
              value={room.roomCount ?? ""}
              onChange={(e) =>
                handleRoomChange(index, "roomCount", e.target.value)
              }
              inputProps={{ min: 1 }}
              fullWidth
            />
          </Grid>

          {/* Daily Price */}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Daily Price"
              type="number"
              value={room.dailyPrice ?? ""}
              onChange={(e) =>
                handleRoomChange(index, "dailyPrice", e.target.value)
              }
              inputProps={{ min: 0 }}
              fullWidth
            />
          </Grid>

          {/* Monthly Price */}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Monthly Price"
              type="number"
              value={room.monthlyPrice ?? ""}
              onChange={(e) =>
                handleRoomChange(index, "monthlyPrice", e.target.value)
              }
              inputProps={{ min: 0 }}
              fullWidth
            />
          </Grid>

          {/* From Date */}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="From Date"
              type="date"
              value={room.fromDate || ""}
              onChange={(e) =>
                handleRoomChange(index, "fromDate", e.target.value)
              }
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Grid>

          {/* To Date */}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="To Date"
              type="date"
              value={room.toDate || ""}
              onChange={(e) =>
                handleRoomChange(index, "toDate", e.target.value)
              }
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Grid>
        </Grid>

        {/* Room details actions */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 1,
            mt: 2,
          }}
        >
          <Button
            type="button"
            variant="outlined"
            fullWidth={isMobile}
            onClick={() => openRoomDetailsDialog(index)}
          >
            Manage Room Details
          </Button>

          <Button
            type="button"
            variant="outlined"
            color="error"
            fullWidth={isMobile}
            onClick={() => removeRoom(index)}
            startIcon={<DeleteIcon />}
          >
            Remove Room
          </Button>
        </Box>
      </Paper>
    ))}

    <Button
      type="button"
      variant="contained"
      startIcon={<AddIcon />}
      onClick={addRoom}
      fullWidth
      sx={{ mt: 1 }}
    >
      Add Room
    </Button>
  </Box>
)}
			
          </Box>
      <Box
  mt={3}
  display="flex"
  flexDirection={{ xs: 'column', sm: 'row' }}
  justifyContent="center"
  alignItems="center"
  gap={2}
  sx={{
    width: '100%',
  }}
>
  <Button
    disabled={!checkPermission("Hostel", "Create Hostel", "CREATE")}
    type="submit"
    variant="contained"
    color="primary"
    sx={{
      width: { xs: '100%', sm: 'auto' },
      minWidth: 140,
    }}
  >
    {hostel ? 'Update Hostel' : 'Create Hostel'}
  </Button>

  <Button
  type="button"
    onClick={onClose}
    variant="outlined"
    color="secondary"
    sx={{
      width: { xs: '100%', sm: 'auto' },
      minWidth: 140,
    }}
  >
    Close
  </Button>
  
</Box>



        </form>
      </Paper>
	  

<Dialog
  open={roomDetailsDialogOpen}
  onClose={closeRoomDetailsDialog}
  fullWidth
  maxWidth="md"
  PaperProps={{
    sx: {
      borderRadius: 2,
      overflow: 'hidden'
    }
  }}
>
  {selectedRoomIndex !== null &&
    formState.roomDetails[selectedRoomIndex] &&
    (() => {
      const room =
        formState.roomDetails[selectedRoomIndex];

      return (
        <>
          {/* =========================
              HEADER
          ========================== */}
          <DialogTitle
            sx={{
              px: { xs: 2, sm: 3 },
              py: 2,
              borderBottom: '1px solid',
              borderColor: 'divider'
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                lineHeight: 1.3
              }}
            >
              Room Details
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mt: 0.5 }}
            >
              Manage room numbers, occupancy, image and pricing
            </Typography>
          </DialogTitle>

          {/* =========================
              CONTENT
          ========================== */}
          <DialogContent
            dividers
            sx={{
              p: { xs: 2, sm: 3 },
              backgroundColor: '#fafafa'
            }}
          >
            {/* =========================
                ROOM SUMMARY
            ========================== */}
            <Box
              sx={{
                mb: 3,
                p: 2,
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'divider',
                backgroundColor: 'background.paper'
              }}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                  display: 'block',
                  mb: 0.5,
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  letterSpacing: 0.5
                }}
              >
                Room Summary
              </Typography>

              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  lineHeight: 1.2
                }}
              >
                {room.roomCount} Rooms
              </Typography>

              <Box
                sx={{
                  mt: 1.5,
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 1
                }}
              >
                {/* Room Type */}
                <Box
                  sx={{
                    px: 1.5,
                    py: 0.6,
                    borderRadius: 1.5,
                    backgroundColor: 'action.hover'
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600 }}
                  >
                    {room.roomType || 'Room Type not set'}
                  </Typography>
                </Box>

                {/* Maximum Occupancy */}
                <Box
                  sx={{
                    px: 1.5,
                    py: 0.6,
                    borderRadius: 1.5,
                    backgroundColor: 'action.hover'
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600 }}
                  >
                    Maximum Occupancy:{' '}
                    {room.maximumRoomOccupancy || '—'}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* =========================
                ROOM INFORMATION
            ========================== */}
            <Typography
              variant="subtitle1"
              sx={{
                mb: 2,
                fontWeight: 700
              }}
            >
              Room Information
            </Typography>
{/* INVENTORY TRACKING TYPE */}
<Grid item xs={12}>
  <Box
    sx={{
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 2,
      p: 2,
      backgroundColor: 'background.paper',
    }}
  >
    <Typography
      variant="subtitle2"
      sx={{ fontWeight: 700, mb: 1 }}
    >
      Inventory Tracking Type
    </Typography>

    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            checked={
              (room.inventoryTrackingType || 'ROOM_BASED') ===
              'ROOM_BASED'
            }
            onChange={() =>
              handleRoomChange(
                selectedRoomIndex,
                'inventoryTrackingType',
                'ROOM_BASED'
              )
            }
          />
        }
        label="Room-based — Track available rooms"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={
              room.inventoryTrackingType === 'BED_BASED'
            }
            onChange={() =>
              handleRoomChange(
                selectedRoomIndex,
                'inventoryTrackingType',
                'BED_BASED'
              )
            }
          />
        }
        label="Bed-based — Track available beds"
      />
    </FormGroup>
  </Box>
</Grid>
            <Grid container spacing={2}>

              {/* =========================
                  ROOM NUMBERS
              ========================== */}
              <Grid item xs={12}>
                <Box
                  sx={{
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 2,
                    p: { xs: 1.5, sm: 2 },
                    backgroundColor: 'background.paper'
                  }}
                >
                  {/* Section Header */}
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: {
                        xs: 'flex-start',
                        sm: 'center'
                      },
                      flexDirection: {
                        xs: 'column',
                        sm: 'row'
                      },
                      gap: 1,
                      mb: 2
                    }}
                  >
                    <Box>
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 700 }}
                      >
                        Room Numbers
                      </Typography>

                      <Typography
                        variant="body2"
                        color="text.secondary"
                      >
                        Room numbers belonging to this room type
                      </Typography>
                    </Box>

                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 700,
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {(room.roomNumbers || []).length} Rooms
                    </Typography>
                  </Box>

                  {/* Room Number Fields */}
                  {(room.roomNumbers || []).length > 0 ? (
                    <Box
                      sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                          xs: '1fr',
                          sm: 'repeat(2, minmax(0, 1fr))',
                          md: 'repeat(4, minmax(0, 1fr))'
                        },
                        gap: 1.5
                      }}
                    >
                      {(room.roomNumbers || []).map(
                        (roomNumber, numberIndex) => (
                         <Box
  key={numberIndex}
  sx={{
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    width: '100%',
    minWidth: 0
  }}
>
  <TextField
    label={`Room ${numberIndex + 1}`}
    value={roomNumber ?? ''}
    onChange={(e) =>
      handleRoomNumberChange(
        selectedRoomIndex,
        numberIndex,
        e.target.value
      )
    }
    placeholder="202"
    size="small"
    fullWidth
    autoComplete="off"
    inputProps={{
      inputMode: 'numeric'
    }}
    sx={{
      flex: 1,
      minWidth: 0
    }}
  />

  <IconButton
    type="button"
    size="small"
    aria-label="Remove room number"
    onClick={() =>
      removeRoomNumber(
        selectedRoomIndex,
        numberIndex
      )
    }
    sx={{
      flexShrink: 0,
      width: 36,
      height: 36,
      ml: 0.5
    }}
  >
    <CloseIcon fontSize="small" />
  </IconButton>
</Box>
                        )
                      )}
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        py: 2,
                        textAlign: 'center',
                        border: '1px dashed',
                        borderColor: 'divider',
                        borderRadius: 1.5
                      }}
                    >
                      <Typography
                        variant="body2"
                        color="text.secondary"
                      >
                        No room numbers added
                      </Typography>
                    </Box>
                  )}

                  {/* Add Room Number */}
                  <Button
  type="button"
  variant="outlined"
  size="small"
  startIcon={<AddIcon />}
  onClick={() => addRoomNumber(selectedRoomIndex)}
>
  Add Room Number
</Button>
                </Box>
              </Grid>

              {/* =========================
                  ROOM TYPE
              ========================== */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Room Type"
                  value={room.roomType || ''}
                  fullWidth
                  InputProps={{
                    readOnly: true
                  }}
                />
              </Grid>

              {/* =========================
                  MAXIMUM OCCUPANCY
              ========================== */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Maximum Occupancy"
                  type="number"
                  value={room.maximumRoomOccupancy || ''}
                  onChange={(e) =>
                    handleRoomChange(
                      selectedRoomIndex,
                      'maximumRoomOccupancy',
                      e.target.value
                    )
                  }
                  fullWidth
                  inputProps={{
                    min: 1
                  }}
                  helperText="Maximum persons one room can accommodate"
                />
              </Grid>

              {/* =========================
                  ROOM IMAGE
              ========================== */}
              <Grid item xs={12}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    mb: 1,
                    fontWeight: 700
                  }}
                >
                  Room Image
                </Typography>

                <Box
                  sx={{
                    border: '1px dashed',
                    borderColor: 'grey.400',
                    borderRadius: 2,
                    p: { xs: 1.5, sm: 2 },
                    textAlign: 'center',
                    backgroundColor: 'background.paper'
                  }}
                >
                  {/* Image Preview */}
                  {room.roomImagePreview ? (
                    <Box>
                      <Box
                        component="img"
                        src={room.roomImagePreview}
                        alt={`Rooms ${
                          room.roomNumbers?.join(', ') || ''
                        }`}
                        sx={{
                          width: '100%',
                          maxHeight: 280,
                          objectFit: 'cover',
                          borderRadius: 2,
                          display: 'block',
                          mb: 2
                        }}
                      />

                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mb: 1.5 }}
                      >
                        {room.roomImageName ||
                          'Room image selected'}
                      </Typography>

                      <Button
                        variant="outlined"
                        component="label"
                        size="small"
                        sx={{
                          textTransform: 'none'
                        }}
                      >
                        Change Image

                        <input
                          hidden
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
                            const file =
                              e.target.files?.[0];

                            if (file) {
                              handleRoomImageChange(
                                selectedRoomIndex,
                                file
                              );
                            }

                            e.target.value = '';
                          }}
                        />
                      </Button>
                    </Box>
                  ) : (
                    <Box>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mb: 2 }}
                      >
                        No room image added
                      </Typography>

                      <Button
                        variant="outlined"
                        component="label"
                        sx={{
                          textTransform: 'none'
                        }}
                      >
                        Upload Room Image

                        <input
                          hidden
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
                            const file =
                              e.target.files?.[0];

                            if (file) {
                              handleRoomImageChange(
                                selectedRoomIndex,
                                file
                              );
                            }

                            e.target.value = '';
                          }}
                        />
                      </Button>
                    </Box>
                  )}
                </Box>
              </Grid>

              {/* =========================
                  DESCRIPTION
              ========================== */}
              <Grid item xs={12}>
                <TextField
                  label="Description"
                  value={room.remark || ''}
                  onChange={(e) =>
                    handleRoomChange(
                      selectedRoomIndex,
                      'remark',
                      e.target.value
                    )
                  }
                  fullWidth
                  multiline
                  rows={3}
                  placeholder="Add any additional room information..."
                />
              </Grid>

            </Grid>
			{/* Enable Microstay Pricing — Room Details popup only */}
<Box sx={{ mt: 2 }}>
  <FormControlLabel
    control={
      <Checkbox
       checked={room.microstayPricingEnabled === "Y"}
onChange={(e) =>
  handleRoomChange(
    selectedRoomIndex,
    "microstayPricingEnabled",
    e.target.checked ? "Y" : null
  )
}
      />
    }
    label="Enable Microstay Pricing"
  />
</Box>

            {/* =========================
                MICROSTAY PRICING
            ========================== */}
           {room.microstayPricingEnabled === "Y" && (
              <Box
                sx={{
                  mt: 3,
                  pt: 3,
                  borderTop: '1px solid',
                  borderColor: 'divider'
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    mb: 2,
                    fontWeight: 700,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}
                >
                  <PaymentsOutlinedIcon fontSize="small" />
                  Microstay Pricing
                </Typography>

                <Grid container spacing={2}>

                  {/* 2–3 Hours */}
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="2–3 Hours"
                      type="number"
                      value={room.price2To3Hours ?? ''}
                      onChange={(e) =>
                        handleRoomChange(
                          selectedRoomIndex,
                          'price2To3Hours',
                          e.target.value
                        )
                      }
                      fullWidth
                      inputProps={{
                        min: 0
                      }}
                    />
                  </Grid>

                  {/* 4–6 Hours */}
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="4–6 Hours"
                      type="number"
                      value={room.price4To6Hours ?? ''}
                      onChange={(e) =>
                        handleRoomChange(
                          selectedRoomIndex,
                          'price4To6Hours',
                          e.target.value
                        )
                      }
                      fullWidth
                      inputProps={{
                        min: 0
                      }}
                    />
                  </Grid>

                  {/* 6–12 Hours */}
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="6–12 Hours"
                      type="number"
                      value={room.price6To12Hours ?? ''}
                      onChange={(e) =>
                        handleRoomChange(
                          selectedRoomIndex,
                          'price6To12Hours',
                          e.target.value
                        )
                      }
                      fullWidth
                      inputProps={{
                        min: 0
                      }}
                    />
                  </Grid>

                </Grid>
              </Box>
            )}
          </DialogContent>

          {/* =========================
              FOOTER
          ========================== */}
          <DialogActions
            sx={{
              px: { xs: 2, sm: 3 },
              py: 2,
              borderTop: '1px solid',
              borderColor: 'divider',
              justifyContent: 'flex-end',
              gap: 1
            }}
          >
            <Button
              onClick={closeRoomDetailsDialog}
              variant="outlined"
              sx={{
                textTransform: 'none'
              }}
            >
              Close
            </Button>

            <Button
              onClick={closeRoomDetailsDialog}
              variant="contained"
              sx={{
                textTransform: 'none'
              }}
            >
              Done
            </Button>
          </DialogActions>
        </>
      );
    })()}
</Dialog>





    </div>
  );
};

export default CreateHostel;
